import { createApi } from './api';
export function create(_ref) {
  let {
    httpClient
  } = _ref;
  const {
    postRetailCarPurchase,
    uploadPurchasingCarPrivateImage
  } = createApi(httpClient);
  return {
    postRetailCarPurchase,
    uploadPurchasingCarPrivateImage
  };
}